var link_viewer_wrapper_rtlignore_default = {
  "anchor": "bT2Qs",
  "link": "vq3HV"
};
export {
  link_viewer_wrapper_rtlignore_default as default
};
//# sourceMappingURL=link-viewer-wrapper.rtlignore-scss.js.map
